//** tabs switch content **//
function nl_switch_content(nl_switch_class) {
    $(".switch-content").hide();
    $(".switch-content.active").show();
    var button = $(nl_switch_class).find(".switch-nav").find(".switch-button");
    var content = $(nl_switch_class).find(".switch-area").find(".switch-content");
    content.each(function(n) {
        var button_class = ("item-" + n);
        $(this).addClass(button_class);
    });
    button.each(function(n) {
        var button_class = ("item-" + n);
        $(this).addClass(button_class);
        $(this).on("click", function (e) {
            e.preventDefault();
            if (!$(this).hasClass("active")) {
                $(this).closest(".switch-nav").find(".switch-button").removeClass("active");
                $(this).addClass("active");
                $(this).parents(nl_switch_class).find(".switch-area").find(".switch-content").hide().removeClass("active");
                $(this).parents(nl_switch_class).find(".switch-area").find(".switch-content").closest(".switch-area").find("."+ button_class).fadeIn();
            }
        });
    });
}

//** more content / text loading **//
function nl_more_content() {
    $(".content-more").each(function () {
        var height = $(this).prev(".content-inner").css("max-height").replace(/[^-\d\.]/g, '');
        var text_length = $(this).prev(".content-inner").find(".content").height();
        if (text_length <= height) {
            $(this).hide();
        } else {
            $(this).show();
        }
        $(this).on("click", function (e) {
            e.preventDefault();
            $(this).find(".more-title").toggleClass("hide");
            $(this).find(".icon").toggleClass("icon-chevron-thin-down").toggleClass("icon-chevron-thin-up");
            if (!$(this).prev(".content-inner").hasClass("active")) {
                $(this).prev(".content-inner").toggleClass("active").css("max-height", text_length + 20 + "px");
            } else {
                $(this).prev(".content-inner").toggleClass("active").attr("style", "");
            }
        });
    });
}

//** check if menu active **//
function nl_check_size() {
    if ($("#main-header").find(".icon-menu").css("display") == "none") {
        $(".header-nav").show().removeClass('toggle');
        $("#bg").fadeOut(300);
        $("body").removeClass("no-scroll");
    } else {
        if ($("#bg").css("display") == "none") {
            $(".header-nav").hide();
        }
    }
}

//** anchor links animation **//
function nl_anchor_link() {
    var anchor_link = $("a[href^='#']");
    anchor_link.on("click", function (e) {
        var id = $(this).attr("href");
        if ($(id).length) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(id).offset().top - 0
            }, 500);
            //$(this).addClass('active');
        }
    });
    if(window.location.hash) {
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top - 0
        }, 500);
    }
}

//** footer pop-up **//
function nl_footer() {
    $(document).on('click', '#nl-logo', function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        $('#nl-logo-popup').fadeToggle('slow');
    });
}

//** cookie window **//
function nl_cookie() {
    var $cookies = $('.cookies');
    if(!$cookies.length) {
        return;
    }
    $cookies.find('.cookies__confirm').on('click', function() {
        var date = new Date();
        date.setFullYear(date.getFullYear() + 10);
        document.cookie = 'cookies-confirmation=1; path=/; expires=' + date.toGMTString();
        $cookies.slideUp();
    });
}

//** touch fix **//
function nl_hover_touch_unstick() {
    // Check if the device supports touch events
    if('ontouchstart' in document.documentElement) {
        // Loop through each stylesheet
        for(var sheetI = document.styleSheets.length - 1; sheetI >= 0; sheetI--) {
            var sheet = document.styleSheets[sheetI];
            // Verify if cssRules exists in sheet
            if(sheet.cssRules) {
                // Loop through each rule in sheet
                for(var ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
                    var rule = sheet.cssRules[ruleI];
                    // Verify rule has selector text
                    if(rule.selectorText) {
                        // Replace hover psuedo-class with active psuedo-class
                        rule.selectorText = rule.selectorText.replace(":hover", ":active");
                    }
                }
            }
        }
    }
}